import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=3940872d&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=3940872d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3940872d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3940872d')) {
      api.createRecord('3940872d', component.options)
    } else {
      api.reload('3940872d', component.options)
    }
    module.hot.accept("./quit.vue?vue&type=template&id=3940872d&scoped=true", function () {
      api.rerender('3940872d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffCustomerManage/quit.vue"
export default component.exports